import moment from 'moment';
import 'moment-timezone';
import Objects from "./Objects";

export const monthDayYear = (timestamp, timezone) => (
    !timezone ? moment(timestamp).format('MMMM Do, YYYY') : moment(timestamp).tz(timezone).format('MMMM Do, YYYY')
);

export const monthDayYearAtTime = (timestamp, timezone) => (
    !timezone ? moment(timestamp).format('MMMM Do, YYYY [at] hh:mm a') : moment(timestamp).tz(timezone).format('MMMM Do, YYYY [at] hh:mm a')
);

const convert = (timestamp, timezone, format) => {
    if (Objects.isNullOrUndefined(timestamp)) {
        return '';
    }
    return !timezone ? moment(timestamp).format(format) : moment(timestamp).tz(timezone).format(format)
};

export const dayMonthYear = (timestamp, timezone) => (
    convert(timestamp, timezone, 'DD/MM/YYYY')
);

export const YearMonthDay = (timestamp, timezone) => (
    convert(timestamp, timezone, 'YYYY-MM-DD')
);

export const HourMinute = (timestamp, timezone) => (
    convert(timestamp, timezone, 'HH:mm')
);

export const HourMinuteSeg = (timestamp, timezone) => (
    convert(timestamp, timezone, 'HH:mm:ss')
);

export const dayMonthYearAtTime = (timestamp, timezone) => (
    convert(timestamp, timezone, 'DD/MM/YYYY HH:mm')
);

export const timeago = (timestamp, timezone) => (
    !timezone ? moment(timestamp).fromNow() : moment(timestamp).tz(timezone).fromNow()
);

export const add = (timestamp, amount, range, timezone) => (
    !timezone ? moment(timestamp).add(amount, range).format() : moment(timestamp).tz(timezone).add(amount, range).format()
);

export const year = (timestamp, timezone) => (
    !timezone ? moment(timestamp).format('YYYY') : moment(timestamp).tz(timezone).format('YYYY')
);

export const getLastDayOfMonths = (month, year) => {
    const startDate = new Date(year, month, 1).toISOString();
    const endDate = new Date(year, month + 1, 0).toISOString();
    return {startDate, endDate}
}

export const diffHorasSegundos = (data1, data2) => {
    const diffEmMs = Math.abs(data2.getTime() - data1.getTime()); // Diferença absoluta em milissegundos
    const totalSegundos = Math.floor(diffEmMs / 1000);
    const horas = Math.floor(totalSegundos / 3600);
    const segundosRestantes = totalSegundos % 3600;
    const minutos = Math.floor(segundosRestantes / 60);
    const segundos = segundosRestantes % 60;

    const horasFormatadas = String(horas).padStart(2, '0');
    const minutosFormatados = String(minutos).padStart(2, '0');
    const segundosFormatados = String(segundos).padStart(2, '0');

    return `${horasFormatadas}:${minutosFormatados}:${segundosFormatados}`;
}

